import { Badge, IconNames } from '@dixa/lib-shared-habla';
import { ReactNode, useMemo } from 'react';

import { ConversationAuditLogEntry } from 'apis/auditLogs';

import {
  getLogEntryAuthorName,
  getLogEntryUserName,
  LogEntry,
} from './logEntry';
import { UserLink } from './userLink/userLink';

type EndUserReplacedProps = {
  entry: ConversationAuditLogEntry<'CONVERSATION_END_USER_REPLACED'>;
};

export const EndUserReplaced = ({
  entry,
}: EndUserReplacedProps): JSX.Element => {
  const text = useMemo((): string | ReactNode => {
    const authorName = getLogEntryAuthorName(entry);
    const newUserDisplayName = getLogEntryUserName(entry.new_user);

    const authorLink = (
      <UserLink userId={entry.author.id}>{authorName}</UserLink>
    );

    const newUserLink = (
      <UserLink userId={entry.new_user.id}>{newUserDisplayName}</UserLink>
    );

    switch (entry.reason) {
      case 'CONTACTS_MERGED':
        return (
          <>
            {authorLink} merged the contact{' '}
            <Badge variant="secondary" size="small">
              {entry.old_user.id}
            </Badge>{' '}
            into {newUserLink}
          </>
        );
      case 'AUTH_UPGRADE_ANONYMOUS_TO_CLAIMED':
        return <>The contact {newUserLink} was upgraded to a claimed contact</>;
      default:
        return 'The contact has been replaced';
    }
  }, [entry]);

  const icon = useMemo((): IconNames | undefined => {
    switch (entry.reason) {
      case 'CONTACTS_MERGED':
        return 'combine';
      case 'AUTH_UPGRADE_ANONYMOUS_TO_CLAIMED':
        return 'user-plus';
    }
  }, [entry]);

  return <LogEntry entry={entry} text={text} icon={icon} />;
};
